import React from 'react';
import { Link } from 'react-router-dom';
// Assets
import { LogoMin } from 'assets/Logos';
// Components
import NavBar from 'components/NavBar';
// Style
import styles from './style/header.module.css';

function Header() {
  return (
    <header className={`${styles.container} wrapper`}>
      <div className={`${styles.content} wrapper__content`}>
        <div>
          <Link to="/">
            <LogoMin />
          </Link>
        </div>
        <NavBar />
      </div>
    </header>
  );
}

export default Header;

